import I18nUtil from '@didi/i18n-util';

const languages = {
  'en-US': 'American English',
  'zh-CN': '简体中文',
  'es-MX': 'Español (México)',
  'pt-BR': 'Portuguese',
  'ja-JP': '日本語',
  'es-419': 'Español (Latinoamérica)',
};

const isRightLocale = locale => {
  return languages[locale] !== void 0;
};
export const getLocale = () => {
  const { getLocale } = I18nUtil;
  return getLocale();
};

export const getLanguageLong = () => {
  const { getLanguageLong } = I18nUtil;
  return getLanguageLong();
};

